import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { TraderOrderList } from '../OrderList';

export const TraderCompletedOrders: React.FC = () => {
  useOrderQueryFilters();

  return (
    <TraderOrderList
      tab={OrdersTab.Completed}
      additionalColumns={[
        AdditionalOrderColumn.TraderPayment,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.AutomationStatus,
      ]}
    />
  );
};
